// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tlsayvwmcqnmdoairbeb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRsc2F5dndtY3FubWRvYWlyYmViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUzODM4NDIsImV4cCI6MjA3MDk1OTg0Mn0.mgcamhsEcu2xSFz5LOxCjcWWLuvt53iySmXpwp-ytG8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});